"use client";

import { Footer as UiFooter } from "@kkeut/ui/footer";
import { useLocale } from "@/components/LocaleProvider";
import { branchConfig } from "@/config/branch";

export default function Footer() {
  const { locale } = useLocale();
  return (
    <UiFooter
      branchId={branchConfig.branchId}
      branchTitle={branchConfig.branchTitle}
      locale={locale}
    />
  );
}
